import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
// import {map} from 'rxjs/operators';
import { utils, write, read, WorkBook, SSF } from 'xlsx-style';
import * as _ from 'lodash';
import { saveAs } from 'file-saver';
//import * from 'jszip';
import { LodashService } from '../../shared/services/lodash.service';

@Injectable({
  providedIn: 'root',
})
export class EfoXlsService {
  Sheets: any = {};
  SheetNames: any[];

  constructor(private efoLd: LodashService) {}

  private datenum(v: string, date1904: boolean): number {
    if (date1904) {
      v += 1462;
    }
    const epoch = Date.parse(v);
    const offset = new Date(Date.UTC(1899, 11, 30));
    // return (epoch - offset) / (24 * 60 * 60 * 1000);
    return (epoch - Date.parse(offset.toDateString())) / (24 * 60 * 60 * 1000);
  }

  private sheet_from_array_of_arrays(data: any, opts: any): any {
    const ws = {};
    const range = { s: { c: 10000000, r: 10000000 }, e: { c: 0, r: 0 } };
    for (let R = 0; R !== data.length; ++R) {
      for (let C = 0; C !== data[R].length; ++C) {
        if (range.s.r > R) {
          range.s.r = R;
        }
        if (range.s.c > C) {
          range.s.c = C;
        }
        if (range.e.r < R) {
          range.e.r = R;
        }
        if (range.e.c < C) {
          range.e.c = C;
        }
        const cell: any = { v: data[R][C] };
        if (cell.v == null) {
          cell.v = '';
          //continue;
        }
        const cell_ref = utils.encode_cell({ c: C, r: R });

        if (typeof cell.v === 'number') {
          cell.t = 'n';
        } else if (typeof cell.v === 'boolean') {
          cell.t = 'b';
        } else if (cell.v instanceof Date) {
          cell.t = 'n';
          // cell.z = SSF._table[14];
          //cell.t = 'd';
          cell.v = this.datenum(cell.v, false);
        } else {
          cell.t = 's';
        }
        //header / first row is blue with one font,
        if (R == 0) {
          cell.s = {
            fill: { fgColor: { rgb: '0F9AEE' } },
            font: { color: { rgb: 'FFFFFF' }, sz: 9 },
            border: { bottom: { style: 'medium', color: { rgb: '888888' } } },
          };
        } else {
          cell.s = {
            fill: { fgColor: { rgb: 'FFFFFF' } },
            font: { color: { rgb: '555555' }, sz: 9 },
          };
        }

        ws[cell_ref] = cell;
      }
    }
    if (range.s.c < 10000000) {
      ws['!ref'] = utils.encode_range(range);
    }
    return ws;
  }

  private Workbook(): void {
    if (!(this instanceof this.Workbook)) {
      return new this.Workbook();
    }
    this.SheetNames = [];
    this.Sheets = {};
  }

  private s2ab(s: any): ArrayBuffer {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  }

  exportDataToXlsx = (
    fileName: string,
    jsonData: any,
    colWidths: any[],
    boostSST: boolean = true,
  ) => {
    /* original data */
    // var data = [[1,2,3],[true, false, null, "sheetjs"],["foo","bar",new Date("2014-02-19T14:30Z"), "0.3"], ["baz", null, "qux"]]
    //  const wb = new this.Workbook();
    const wb = {
      SheetNames: [],
      Sheets: {},
    };
    /* add worksheet to workbook */
    _.each(jsonData, (d, k) => {
      const ws_name = k;
      wb.SheetNames.push(ws_name);
      const ws = this.sheet_from_array_of_arrays(this.efoLd.jsonToRows(d), {});
      if (true) {
        //auto widths
        colWidths = _.map(_.keys(d[0]), function (k) {
          //The 5 with trunc gives a min width of 4
          return Math.trunc(
            _.max(
              _.map(_.map(d, k), function (v) {
                return !v
                  ? k.length
                  : _.max([k.length, v.toString().length, 5]);
              }),
            ) * 0.9,
          );
        });
      }
      var maxColWidth = 100;
      colWidths = _.map(colWidths, function (d) {
        return d > maxColWidth ? maxColWidth : d;
      });
      const wscols = _.map(colWidths, function (dd) {
        return { wch: dd };
      });
      ws['!cols'] = wscols;
      wb.Sheets[k] = ws;
    });
    // wb.Sheets[ws_name] = ws;

    /* write file */
    // XLSX.writeFile(wb, 'test.xlsx');
    /* write file direct*/
    const wbout = write(wb, {
      bookType: 'xlsx',
      bookSST: boostSST,
      type: 'binary',
    });

    saveAs(
      new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
      fileName + '.xlsx',
    );
  };
}
